import React from 'react'
import { useEffect, useState } from 'react'
import { PrismicRichText, PrismicText } from '@prismicio/react'
import './BlogPages.scss'
import RelatedCardFr from '../RelatedCard'
import moment from 'moment'
// @ts-ignore
import userIcon from "../../assets/img/old/icons/user.png";
// @ts-ignore
import calendarIcon from "../../assets/img/old/icons/calendar.png";
// @ts-ignore
import clockIcon from "../../assets/img/old/icons/clock.png";
// @ts-ignore
import faceBook from "../../assets/img/facebook.png";
// @ts-ignore
import youtube from "../../assets/img/youtube.png";
// @ts-ignore
import linkedin from "../../assets/img//linkedinRed.png";
// @ts-ignore
import twitter from "../../assets/img/twitter.png";
// @ts-ignore
import instagram from "../../assets/img/instagram.png";
import * as prismic from "@prismicio/client";
import StickyBox from "react-sticky-box";

interface Props {
    blog: any;
}

const NewBlogPageFr = ({ blog }: Props) => {
    const doc = blog?.dataRaw;

    const repositoryName = "new-coachello-blog";
    const accessToken =
        "MC5aMXdDbVJJQUFDMEFIQWE4.77-977-9DO-_vRNm77-977-9I1Xvv73vv73vv707VO-_ve-_vULvv71P77-977-9EEdv77-9Fe-_ve-_ve-_ve-_vTc";
    const Client = prismic.createClient(repositoryName, {
        accessToken,
    });

    const [relatedPosts, setRelatedPosts] = useState<any[]>([]);
    const [faqs, setFaqs] = useState<any[]>([]);
    const [expandedIndices, setExpandedIndices] = useState<Set<number>>(new Set());
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        if (typeof window !== "undefined") {
            setCurrentUrl(window.location.href);
        }
    }, []);

    const fetchRelatedContent = async () => {
        if (!doc?.body || !Array.isArray(doc.body)) return;

        const relatedPostsSlice = doc.body.find((slice: any) => slice.slice_type === 'related_posts');
        const faqSlice = doc.body.find((slice: any) => slice.slice_type === 'faqsection');

        if (relatedPostsSlice && relatedPostsSlice.items?.length > 0) {
            const refs = relatedPostsSlice.items.map((item: any) =>
                item.related_posts?.id || item.related_posts?.uid || item.question?.id || null
            ).filter(Boolean);

            const fetchedPosts = await Promise.all(
                refs.map(async (ref: string) => {
                    try {
                        let response = null;

                        // by ID
                        response = await Client.getByID(ref).catch(() => null);

                        // If failed and ref is UID-like
                        if (!response && typeof ref === 'string' && ref.length < 30) {
                            response = await Client.getByUID('old_blog_page', ref).catch(() => null)
                                || await Client.getByUID('new_blog_page', ref).catch(() => null);
                        }

                        if (!response) return null;

                        const titleField = response?.data?.title;
                        const subjectField = response?.data?.subject;

                        return {
                            title: Array.isArray(titleField)
                                ? titleField
                                : [{ type: 'heading1', text: titleField || 'Untitled', spans: [] }],

                            subject: Array.isArray(subjectField)
                                ? subjectField
                                : [{ type: 'paragraph', text: subjectField || '', spans: [] }],

                            imageSrc: response?.data?.image?.url || '',
                            link: `/blog/${response.uid}`,
                        };
                    } catch (error) {
                        console.error(`Error fetching post for ref ${ref}:`, error);
                        return null;
                    }
                })
            );

            const validPosts = fetchedPosts.filter(post => post !== null);
            setRelatedPosts(validPosts);
        }

        // FAQ section
        if (faqSlice && faqSlice.items?.length > 0) {
            const faqItems = faqSlice.items.map((item: any) => ({
                faq_question: item.faq_question || '',
                faq_answer: item.faq_answer || ''
            }));

            setFaqs(faqItems);
        }
    };

    useEffect(() => {
        fetchRelatedContent();
    }, [doc]);

    const generateId = (text: any) => {
        return text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    return (
        <div className="bg-warm">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 px-6 sm:px-12 md:px-20 lg:px-32 pt-12 lg:pt-24 bg-warm">

                <div className="lg:col-span-2 p-4 items-center">
                    <img
                        className="w-full rounded-xl mb-4"
                        style={{ maxHeight: "400px" }}
                        src={blog?.data?.image?.url}
                        alt={blog?.data?.image?.alt}
                    />
                    <PrismicRichText field={doc.title}
                        components={{
                            heading1: ({ node, children, key }) => {
                                return (
                                    <h1 className='text-5xl'>
                                        {children}
                                    </h1>
                                );
                            }
                        }}
                    />

                    {/* BreadCrumb Bar */}

                    <div className="flex items-center space-x-6 pt-3 pb-10">
                        <p className="flex items-center space-x-2">
                            <img className="h-5 w-5" src={calendarIcon} alt="calendar icon" />
                            <span>{moment(doc?.date_of_publication).format("MMMM D, YYYY")}</span>
                        </p>
                        <p className="flex items-center space-x-2">
                            <img className="h-5 w-5" src={clockIcon} alt="clock icon" />
                            <span>{doc.read_time ? <PrismicText field={doc.read_time} /> : "5mins"}</span>
                        </p>
                        {doc.author && doc.author.length !== 0 &&
                            <p className="flex items-center space-x-2">
                                <img className="h-5 w-5" src={userIcon} alt="user icon" />
                                <span><PrismicText field={doc?.author} /></span>
                            </p>}
                    </div>

                    <PrismicRichText
                        field={doc.text}
                        components={{
                            heading3: ({ node, children, key }) => {
                                return (
                                    <h3 style={{
                                        fontSize: '1.5rem',
                                        marginBottom: '0.5rem',
                                        marginTop: '0.5rem',
                                    }}>
                                        {children}
                                    </h3>
                                );
                            },
                            heading2: ({ node, children, key }) => {
                                const headingId = generateId(node.text);
                                return (
                                    <h2 id={headingId} key={key} style={{
                                        // lineHeight: '1.5',
                                        fontSize: '2.5rem',
                                        marginBottom: '1rem',
                                        marginTop: '1rem',
                                        scrollMarginTop: '100px'
                                    }}>
                                        {children}
                                    </h2>
                                );
                            },
                            hyperlink: ({ node, children, key }) => (
                                <a
                                    key={key}
                                    href={node.data.url}
                                    style={{ color: "#FD0054", fontWeight: "bold" }}
                                >
                                    {children}
                                </a>
                            ),
                            image: ({ node, key }) => (
                                <img
                                    src={node.url}
                                    alt={node.alt || 'Custom Alt Text'}
                                    style={{
                                        marginTop: '20px',
                                        marginBottom: '20px',
                                        borderRadius: '10px',
                                        width: '100%',
                                        height: "400px",
                                        objectFit: 'cover',
                                    }}
                                />
                            ),
                            paragraph: ({ children, key }) => (
                                <p
                                    key={key}
                                    style={{
                                        lineHeight: '1.5',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    {children}
                                </p>
                            ),
                            list: ({ children, key }) => (
                                <ul
                                    key={key}
                                    style={{
                                        marginBottom: '1rem',
                                    }}
                                >
                                    {children}
                                </ul>
                            ),
                            oList: ({ children, key }) => (
                                <ol
                                    key={key}
                                    style={{
                                        marginBottom: '1rem',
                                    }}
                                >
                                    {children}
                                </ol>
                            ),
                        }}

                    />
                </div>

                <div className="p-4 bg-warm">
                    <StickyBox offsetTop={100} offsetBottom={20}>
                        <div className="mb-6 bg-white rounded-xl px-5 pt-3 border border-gray-300">
                            <h4 className=" font-gambetta font-bold ">Partager cet article</h4>
                            <div className="flex items-center justify-between pt-3 pb-3">
                                <a
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="h-10 w-10" src={faceBook} alt="Facebook icon" />
                                </a>
                                <a
                                    href={`https://www.instagram.com`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="h-10 w-10" src={instagram} alt="Instagram icon" />
                                </a>
                                <a
                                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(doc.title[0]?.text || "Check out this article!")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="h-10 w-10" src={twitter} alt="Twitter icon" />
                                </a>
                                <a
                                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=${encodeURIComponent(doc.title[0]?.text || "Check out this article!")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="h-10 w-10" src={linkedin} alt="Linkdein icon" />
                                </a>


                            </div>
                        </div>

                        {doc.text.some((block: any) => block.type === 'heading2') && (
                            <div className="mb-6 bg-white rounded-xl pl-5 py-3 border border-gray-300">
                                <h4 className="font-bold font-gambetta mb-3">Contenu</h4>
                                <ul className="list-decimal text-gray-500 px-5 space-y-2">
                                    {doc.text.map((block: any, index: any) => {
                                        if (block.type === 'heading2') {
                                            const headingId = generateId(block.text);
                                            return (
                                                <li key={index} className="hover:text-red">
                                                    <a href={`#${headingId}`} className="hover:text-red">
                                                        {block.text}
                                                    </a>
                                                </li>
                                            );
                                        }
                                        return null;
                                    })}
                                </ul>
                            </div>
                        )}

                        {faqs.length > 0 && (
                            <div className="mb-6 bg-white rounded-xl pl-5 py-3 border border-gray-300">
                                <h4>
                                    <a href="#faq-section" className="font-bold font-gambetta mb-3 hover:text-red">FAQ</a>
                                </h4>
                            </div>
                        )}

                        {relatedPosts.length !== 0 && (
                            <div className="mb-6 bg-white rounded-xl pl-5 py-3 border border-gray-300">
                                <h4 className="font-bold font-gambetta mb-3">Articles connexes</h4>
                                <ul
                                    className="list-none space-y-4 pl-0 ml-0"
                                >
                                    {relatedPosts.map((post, index) => (
                                        <li key={index}>
                                            <a href={post.link} className="hover:text-red">
                                                <PrismicText field={post.title || "Untitled Post"} />
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {doc.author && doc.author.length !== 0 &&
                            <div className="mb-6 bg-white rounded-xl pl-5 pt-3 border border-gray-300">
                                <h4 className="font-bold font-gambetta mb-3">Auteur</h4>
                                {doc?.author_photo?.url && <img className="h-20 w-20 rounded-full" src={doc?.author_photo?.url} />}

                                <div className="flex items-center space-x-6 pt-1 pb-1">
                                    <div>
                                        <p className="font-medium"><PrismicText field={doc?.author} /></p>
                                        <p ><PrismicText field={doc?.author_description} /></p>
                                        <div className="flex items-center space-x-3 pt-3 pb-3">
                                            {doc?.author_facebook?.url && <a href={doc?.author_facebook?.url}><img className="h-7 w-7" src={faceBook} alt="facebook icon" /></a>}
                                            {doc?.author_instagram?.url && <a href={doc?.author_instagram?.url}><img className="h-7 w-7" src={instagram} alt="instagram icon" /></a>}
                                            {doc?.author_twitter?.url && <a href={doc?.author_twitter?.url}><img className="h-7 w-7" src={twitter} alt="twitter icon" /></a>}
                                            {doc?.author_youtube?.url && <a href={doc?.author_youtube?.url}><img className="h-7 w-7" src={youtube} alt="youtube icon" /></a>}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </StickyBox>
                </div>
            </div>

            {/* FAQ Section */}
            {faqs.length > 0 && (
                <div id="faq-section" className="bg-warm sm:px-12 md:px-20 lg:px-32 py-10">
                    <h3 className="font-bold font-gambetta mb-6">
                        Foire Aux Questions
                    </h3>
                    <div className="space-y-4 mt-6">
                        {faqs.map((faq, index) => {
                            const isActive = expandedIndices.has(index);
                            return (
                                <div
                                    key={index}
                                    className="p-4 cursor-pointer border-b border-gray-300"
                                    onClick={() => {
                                        const newSet = new Set(expandedIndices);
                                        if (newSet.has(index)) {
                                            newSet.delete(index);
                                        } else {
                                            newSet.add(index);
                                        }
                                        setExpandedIndices(newSet);
                                    }}
                                >
                                    <div className="flex justify-between items-center">
                                        <h3 className="font-bold text-lg">
                                            <PrismicRichText field={faq.faq_question} />
                                        </h3>
                                        <span className="text-xl font-bold">{isActive ? "−" : "+"}</span>
                                    </div>
                                    {isActive && (
                                        <div className="mt-2 text-gray-700">
                                            <PrismicRichText field={faq.faq_answer} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {relatedPosts.length !== 0 &&
                <div className="bg-warm sm:px-12 md:px-20 lg:px-32 py-10">
                    <h3 className="font-bold font-gambetta mb-3">Articles connexes</h3>
                    <div className="grid md:grid-cols-3 gap-8">
                        {relatedPosts.map((post, index) => (
                            <a href={post.link} >
                                <RelatedCardFr key={index} data={post} />
                            </a>
                        ))}
                    </div>
                </div>
            }
        </div>

    )
}

export default NewBlogPageFr;